// お気に入り機能
class FavoriteManager {
  constructor() {
    this.favorites = this.loadFavorites();
    this.init();
  }

  // ローカルストレージからお気に入りを読み込み
  loadFavorites() {
    const saved = localStorage.getItem('favorites');
    return saved ? JSON.parse(saved) : [];
  }

  // ローカルストレージにお気に入りを保存
  saveFavorites() {
    localStorage.setItem('favorites', JSON.stringify(this.favorites));
  }

  // お気に入りに追加
  addFavorite(productId) {
    if (!this.favorites.includes(productId)) {
      this.favorites.push(productId);
      this.saveFavorites();
      this.updateUI(productId, true);
    }
  }

  // お気に入りから削除
  removeFavorite(productId) {
    const index = this.favorites.indexOf(productId);
    if (index > -1) {
      this.favorites.splice(index, 1);
      this.saveFavorites();
      this.updateUI(productId, false);
    }
  }

  // お気に入り状態を切り替え
  toggleFavorite(productId) {
    if (this.favorites.includes(productId)) {
      this.removeFavorite(productId);
    } else {
      this.addFavorite(productId);
    }
  }

  // UIを更新
  updateUI(productId, isFavorited) {
    const card = document.querySelector(`[data-product-id="${productId}"]`);
    if (card) {
      const btn = card.querySelector('.favorite-btn');
      const heartIcon = btn.querySelector('.heart-icon');
      const heartFilled = btn.querySelector('.heart-filled');
      
      if (isFavorited) {
        btn.classList.add('favorited');
        btn.setAttribute('aria-label', 'お気に入りから削除');
        heartIcon.style.display = 'none';
        heartFilled.style.display = 'block';
      } else {
        btn.classList.remove('favorited');
        btn.setAttribute('aria-label', 'お気に入りに追加');
        heartIcon.style.display = 'block';
        heartFilled.style.display = 'none';
      }
    }
  }

  // 初期化
  init() {
    // 既存のお気に入り状態を復元
    this.favorites.forEach(productId => {
      this.updateUI(productId, true);
    });

    // お気に入りボタンのイベントリスナーを設定
    document.addEventListener('click', (e) => {
      if (e.target.closest('.favorite-btn')) {
        e.preventDefault();
        e.stopPropagation();
        
        const btn = e.target.closest('.favorite-btn');
        const card = btn.closest('[data-product-id]');
        const productId = card.getAttribute('data-product-id');
        
        this.toggleFavorite(productId);
      }
    });
  }
}

// DOMContentLoadedイベントで初期化
document.addEventListener('DOMContentLoaded', () => {
  new FavoriteManager();
});
